<template lang="pug">
  .income
    v-container.px-0(:class="isPrinting? 'py-0' : ''" style="max-width:800px")
      PackingSlips(fill-width :pid="pid")

</template>

<script>
import PackingSlips from '@/components/ordermgmt/PackingSlips.vue'

export default {
  name: 'YezzaPackingSlips',
  props: ['pid'],
  components: { PackingSlips },
  computed: {
    isPrinting () {
      if (this.$route.path.includes('print-packing-slips')) {
        return true
      }
      return false
    }
  },
  data: () => ({
  })
}
</script>

<style lang="scss" scoped>
</style>


<style scoped>
</style>
